// src/mockApi.ts
export const submitForm = (): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 3000); // Mock delay of 3 seconds
  });
};
